import React, { useMemo } from "react";
import { ChakraProvider, ColorModeScript, } from "@chakra-ui/react";
import { ASSET_URL } from "./constants";
import Fonts from "./Fonts";
import { AssetsContext } from "../hooks/useWebAssets";
import defaultTheme from "./defaultTheme";
function TP(props) {
    const { children, theme = defaultTheme, resetCSS = false, includeFonts = true, assetUrl = ASSET_URL, } = props;
    const assetData = useMemo(() => ({ assetUrl }), [assetUrl]);
    return (React.createElement(ChakraProvider, { theme: theme, resetCSS: resetCSS },
        React.createElement(AssetsContext.Provider, { value: assetData },
            React.createElement(ColorModeScript, { initialColorMode: theme.config.initialColorMode }),
            children,
            includeFonts && React.createElement(Fonts, null))));
}
export default TP;
//# sourceMappingURL=ThemeProvider.js.map